import React, { FC } from "react";
import { InputNumber } from "antd";
import format from "../../../constants/format";
import { InputWrapper } from "./elements";
import { CurrencyInputProps } from "./types";

const CurrencyInput: FC<CurrencyInputProps> = (props) => {
  const { onChange, disabled, value } = props;

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const currency = /^[0-9\b]+$/
    currency.test(e.key) || e.preventDefault();
  }

  return (
    <InputWrapper>
      <InputNumber
        formatter={(value: number | undefined) =>
          `${value}`.replace(format.currencyMask, ",")
        }
        // @ts-ignore
        parser={(value: string) => value.replace(format.currencyParser, "")}
        onChange={onChange}
        onKeyPress={handleKeyPress}
        disabled={disabled || false}
        value={value}
        style={{ width: "100%" }}
        min={0}
        controls={false}
      />
    </InputWrapper>
  );
};
export default CurrencyInput;
